import React from "react";
import { Switch, Button } from "antd";
import { CheckSquareOutlined, CloseOutlined } from "@ant-design/icons";

const columns = [
  {
    title: "Kit Name",
    dataIndex: "kitname",
    sorter: (a, b) => a.kitname.localeCompare(b.kitname),
    render: (_, record) => <Button type="link"></Button>,
    fixed: 'left',
    width: 200,    
    onCell: () => ({
      className: 'bc-product-name-cell-button',
    }),
  },
  {
    title: "Kit Type",
    dataIndex: "kitType",
    sorter: (a, b) => {
      const toType = (r) => (r.is_multi_kit_prod === 1 ? "Multi Kit" : r.is_kit_prod === 1 ? "Kit" : "Other");
      return toType(a).localeCompare(toType(b));
    },
    render: (_, record) => (record.is_multi_kit_prod === 1 ? "Multi Kit" : record.is_kit_prod === 1 ? "Kit" : "Other"),
    width: 100,    
    onCell: () => ({
      className: 'bc-product-name-cell-button',
    }),
  },
  {
    title: "BC MSRP",
    dataIndex: "msrp",
    width: 100, 
    sorter: (a, b) => {
      const parseMsrp = (msrp) => {
        if (!msrp) return 0;
        // Remove currency symbol and commas, then parse as float
        return parseFloat(msrp.replace(/[^0-9.]/g, "")) || 0;
      };
      return parseMsrp(a.msrp) - parseMsrp(b.msrp);
    },
    render: (_, record) => record.currency_symbol + record.msrp|| "N/A",
  },
  {
    title: "BC Sale Price",
    dataIndex: "sale_price",
    width: 130, 
    render: (_, record) => record.currency_symbol + record.sale_price|| "N/A",
  },
  
  {
    title: "BC Product (SKU)",
    dataIndex: "bcSku",
    width: 130, 
  },
  {
    title: "BC Primary Product (Kit)",
    dataIndex: "bcPrimarySku",
    width: 190, 
  },  
  {
    title: "BC Multi Kit Product",
    dataIndex: "multi_kit_prods",
    width: 260,
    render: (_, record) => {
      if (Number(record?.is_multi_kit_prod) !== 1 || !Array.isArray(record?.multi_kit_prods)) return "�";
      const products = record.multi_kit_prods.flatMap(g => Array.isArray(g?.products) ? g.products : []);
      const text = products.map(p => p?.sku || p?.productName).filter(Boolean).join(", ");
      return text || "�";
    },
  }, 
  {
    title: "Active on Store",
    dataIndex: "active",
    render: (_, record) => <Switch checked={record.active} />,
    width: 130, 
  },
  {
    title: "Store",
    dataIndex: "store",
    width: 100, 
  },
  {
      title: "Enrichment",
      dataIndex: "enrichment",
      render: (text) =>
        text ? (
          <CheckSquareOutlined style={{ color: "green" }} />
        ) : (
          <CloseOutlined style={{ color: "red" }} />
        ),
      // sorter: (a, b) => (a.enrichment === b.enrichment ? 0 : a.enrichment ? 1 : -1),
      width: 150,
      ellipsis: true,
    },
  {
    title: "Last Updated",
    dataIndex: "lastUpdated",
    width: 150, 
  },
];

export default columns;
